// extracted by mini-css-extract-plugin
export default {"header_bg":"HeaderSelectTrain_header_bg__1sI4F"};